import { IImage } from "@faire/web-api/indigofair/data/IImage";
import { useQueryClient } from "@tanstack/react-query";
import React, { useCallback } from "react";

import { ProductTileContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import { useProductTileClickImpressions } from "@faire/retailer/hooks/ProductTileImpression/useProductTileClickImpressions";
import { preloadNavigationToPDP } from "@faire/retailer/views/product/preload/preloadNavigationToPDP";

export interface IOnProductClickBase {
  token?: string;
  bestImage?: IImage;
  images?: Array<IImage>;
  impressionId?: string;
}

export const useOnProductClickBase = <T extends IOnProductClickBase>(
  params: T
) => {
  const { recordAdImpression, brand, brandToken } =
    React.useContext(ProductTileContext);
  const queryClient = useQueryClient();

  const { recordProductTileClickEvent } = useProductTileClickImpressions(
    params,
    brandToken ?? brand?.token,
    recordAdImpression
  );

  return useCallback(() => {
    recordProductTileClickEvent();
    preloadNavigationToPDP(queryClient, {
      ...params,
      productToken: params.token,
      bestImage: params.bestImage,
      images: params.images ?? [],
    });
  }, [recordProductTileClickEvent, params, queryClient]);
};
